<template>
    <el-dialog id="ipSearchDialog" :title="title" :visible.sync="dialogVisible" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div v-if="!!showError.isShow" class="mb15">
            <el-alert :title="$t(showError.message)" type="warning" show-icon @close="showError.isShow = false"></el-alert>
        </div>
        <el-row :gutter="15">
            <el-col :span="4">
                <slot name="select"></slot>
            </el-col>
            <el-col :span="15">
                <el-input v-model="seachValue" @keyup.enter.native="search" size="small" :placeholder="placeholder">
                    <el-button icon="el-icon-search" @click="search" slot="append"></el-button>
                </el-input>
            </el-col>
        </el-row>
        <el-row class="corp-code-container" :gutter="15" v-loading="loading">
            <template v-for="item in list">
                 <el-col :span="row">
                        <div class="corp-code">
                            <slot name="content" v-bind:data="item.treeData">
                                <h3 v-if="!!item.title">{{item.title}}</h3>
                                <div class="corp-code-tree" :style="{height:!!item.title ? '291px':'327px'}">
                                    <ip-tree :dataSet="item.treeData" @nodeClick="handleNodeClick" @checkboxChangeEvent="handleCheckboxChangeEvent" @expandEvent="handleExpandEvent"></ip-tree>
                                </div>
                            </slot>
                        </div>
                </el-col>
            </template>    
            <el-col :span="8">
                 <div class="corp-code">
                    <h3>{{$t(checkTitle)}}
                        <el-button class="pull-right" size="mini" type="primary" @click="clearCheckList">{{clearText}}</el-button>
                    </h3>
                    <ul class="corp-code-tree">
                        <li v-for="(item,index) in checkList">
                            <i class="del-btn el-icon-close" @click="deleteCheck(item,index)"></i>
                            <span>{{item.text}}</span>
                        </li>
                    </ul>
                </div>
            </el-col>
        </el-row>
         <div slot="footer" class="dialog-footer">
             <el-button  size="small" @click="closeDialog">{{closeText}}</el-button>
            <el-button  size="small" type="primary" @click="submit">{{confirmText}}</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name:'ipSearchModel',
    props:{
        title:{type:String,default:''},
        visible: {type: Boolean,default: false},
        width:{type: String,default: ''},
        placeholder:{type:String,default:''},
        rowspan:{type:Number,default:2},
        list:{type:Array,default(){return []}},
        checkTitle:{type:String,default:''},
        checkList:{type:Array,default(){return []}},
        loading:{type:Boolean,default:false},
        showError:{type:Object,default(){return {}}},
        closeText:{type:String,default:'关闭'},
        confirmText:{type:String,default:'确定'},
        clearText:{type:String,default:'清除'}
    },
    data(){
        return{
            seachValue:''
        }
    },
    computed:{
        dialogVisible:{
            get(){return this.visible},
            set(){}
        },
        row:{
            get(){
                return (24 - 8)/(this.rowspan-1)
            },
            set(){}
        }
    },
    methods:{
        handleExpandEvent(node){
            this.$emit('expand',node);
        },
        closeDialog(){
            this.$emit('close-dialog');
        },
        search(){
            this.$emit('search',this.seachValue);
        },
        submit(){
            this.$emit('submit');
        },
        clearCheckList(){
            this.$emit('clear-check-list');
        },
        handleNodeClick(node){
            this.$emit('node-click',node);
        },
        deleteCheck(item,index){
            this.$emit('delete-check',item,index);
        },
        handleCheckboxChangeEvent(node){
            this.$emit('checkbox-change',node);
        }
    }
}
</script>
<style lang="scss">
#ipSearchDialog {
    .el-dialog__body{
        padding: 15px 20px;
    }
    .el-dialog__header {
        background: $theme-color;
        height: 40px;
        line-height: 40px;
        padding: 0px 15px;
        box-sizing: border-box;
        .el-dialog__title{
            font-size: 16px;
            color: #ffffff;
        }
        .el-dialog__headerbtn{
            top: 12px;
        .el-dialog__close{
            color: #ffffff;
        }
        }
    }
}
</style>
<style lang="scss" scoped>
.mb15{
        margin-bottom:15px;
}
.corp-code-container {
    margin: 15px 0 0 0;
    .corp-code{
            border: 1px solid #cccccc;
            height: 329px;
            overflow-y: auto;
        h3{
            font-size: 12px;
            color: #333333;
            padding: 4px 8px;
            margin: 0;
            font-weight: normal;
            background: #e8f0f8;
            height: 36px;
            line-height:28px;
            box-sizing:border-box;
        }
        ul{
            margin:0;
            padding:0;
        }
        .corp-code-tree{
            height: 291px;
            overflow: auto;
            li{
                padding:3px 0;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                position: relative;
            }
            .del-btn{
                color: $theme-color;
                padding:0 5px;
                cursor: pointer;
            }
        }
    }
}
</style>

